module.exports = __webpack_public_path__ + "media/images/platforms/xbox/background-0e9b92275e94dc6b0eabfc669ee4f04c.jpg";